import React, { HTMLAttributes } from 'react';
import { domPurify } from '../../utils/dom';

type SafeHtmlProps = {
  content: string;
} & HTMLAttributes<HTMLDivElement>;

export const SafeHtml = ({ content, ...rest }: SafeHtmlProps) => {
  return (
    <div {...rest} dangerouslySetInnerHTML={{ __html: domPurify(content) }} />
  );
};
